import React from 'react';
import './card.css'

function NewsCard({ props }){
  return !props.image? []: (
     <div className="cards">
      <a href={props.url}><img src={props.image} alt="MIA" /></a>
     <div className="cards-text">
      <h3>{props.title}Hello</h3>
      <p>{props.description}  <a className="aColor" href={props.url}>Read More</a></p>
      <p>{props.publishedAt}</p>
      </div>
     </div>
  )
}
export default NewsCard


//Notes: Filter out articles that do not have images
// *** return !props.urlToImage? []: ***  do not return props without image urls, [] - means stop here
//Syantax: condition ? value_if_true : value_if_false

//return !props.urlToImage? [] : (<div>...</div>)
//if props has no image, then stop here, else return the div
